import React from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-teal/20 to-transparent" data-id="element-888" />

      <section className="section-padding bg-dark-bg relative overflow-hidden" data-id="element-889">
        {/* Subtle Ambient Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple/10 rounded-full blur-[150px] opacity-40 pointer-events-none" data-id="element-890" />

        <div className="inner-container max-w-4xl relative z-10" data-id="element-891">
          <div className="mb-12" data-id="element-892">
            <span className="text-purple text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-893">
              The Origin
            </span>
          </div>

          <div className="space-y-10 text-lg md:text-xl text-steel leading-relaxed font-inter" data-id="element-894">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-895">
              David lost $284k. He had investors walk away. He suffered the
              health consequences of working non-stop, carrying the weight of an
              entire operation on his shoulders.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} data-id="element-896">
              The sleepless nights. The racing mind. The endless cycle of
              telling a team what to do, only to realize three weeks later that
              nothing was done.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="my-16 pl-8 border-l-4 border-transparent relative" data-id="element-897">
              <div className="absolute left-[-4px] top-0 bottom-0 w-1 bg-gradient-to-b from-purple to-teal" data-id="element-898" />
              <div className="absolute inset-0 bg-purple/5 blur-xl -z-10" data-id="element-899" />
              <p className="font-poppins font-bold text-3xl md:text-4xl text-white italic leading-tight" data-id="element-900">
                "I didn't build this from a business school theory. I built it
                because I lived the nightmare you're living."
              </p>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} data-id="element-901">
              Every hardship became the exact answer key to every client's
              problem. Like{' '}
              <span className="text-white font-medium" data-id="element-902">
                Slumdog Millionaire
              </span>{' '}
              — everything David went through was exactly the answer to every
              question business owners are asking today.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} data-id="element-903">
              MindStream.ing wasn't built to be just another software tool. It
              was built to kill the devil in the details. It was built to give
              you back your sanctity, your family time, and your sleep.
            </motion.p>
          </div>
        </div>
      </section>
    </>;
}